const slideshow = state => {
  const out: any = [];
  for (let i = 1; i < 8; i++) {
    out.push('./static/slideshow-images/slideshow_image' + i + '.jpg');
  }
  return out;
};

export {
  slideshow
};
